import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FavoriteProductTile from '../components/FavoriteProductTile';

export default function Favorites() {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="Checkout-top">
        <Navbar />
      </div>
      <div className="bg-red-50 Checkout-feed flex-grow pb-[1%] relative w-[90%] mx-auto rounded-2xl z-10 top-28 mb-40 shadow-xl">
        <div className="feed-title w-[100%] border-b-2 py-[1%] mx-auto" style={{ borderBottom: '1px solid #c3baba' }}>
          <span className="text-amber-950 font-bold font-poppins text-2xl text-left ml-4">MY WISHLIST</span>
        </div>
        <div className="feed-container w-[96%] my-[2%] mx-auto">
          <FavoriteProductTile />
        </div>
      </div>
      <div className="Cart-bottom mb-0">
        <Footer />
      </div>
    </div>
  );
}